import React, { useState } from 'react';
import SectionLayout from '../layouts/SectionLayout/index';
import { StaticImage } from 'gatsby-plugin-image';
import RoundedLayout from '../layouts/RoundedLayout/index';
import ImageWithHover from '@components/Common/ImageWithHover/index';

const InTheNewsSection = React.memo(function InTheNewsSection() {
  return (
    <RoundedLayout roundedBg="bg-v5-green-100" className="bg-white">
      <SectionLayout heading="In The News">
        <div className="container mt-24 mb-16 sm:mt-0">
          <div className="flex h-full flex-wrap items-stretch justify-center gap-x-4 gap-y-4  sm:flex-nowrap">
            <a
              rel="noreferrer"
              href="https://mybigplunge.com/business/edtech/edtech-firm-crio-do-achieves-over-2000-placements-in-top-tech-companies-sets-ambitious-goal-for-the-future/"
              target="_blank"
              className={` group flex  h-full cursor-pointer flex-col items-center gap-y-2 rounded-[20px] bg-v5-neutral-200 p-5 text-center transition-all hover:bg-v5-green-100 hover:text-black sm:max-w-[220px] sm:items-start sm:text-left`}
            >
              <div className="-mt-24 block sm:hidden ">
                <StaticImage
                  width={120}
                  loading="lazy"
                  src="../../../images/v5/News/Highlight.png"
                  placeholder="blurred"
                  alt="Difference"
                />
              </div>
              <div className="hidden sm:block ">
                <StaticImage
                  width={200}
                  loading="lazy"
                  src="../../../images/v5/News/Plunge.webp"
                  placeholder="blurred"
                  alt="Difference"
                />
              </div>
              <p
                className={`font-bold 
                  leading-relaxed text-v5-neutral-400 group-hover:text-black`}
              >
                Edtech Firm Crio.Do Achieves Over 2,000 Placements in Top Tech
                Companies, Sets Ambitious Goal for the Future
              </p>
            </a>

            <div className="flex flex-col gap-y-4 sm:max-w-[550px]">
              <div className="">
                <NewsCard
                  href=""
                  image={
                    <StaticImage
                      width={150}
                      loading="lazy"
                      src="../../../images/v5/News/TheHindu.webp"
                      placeholder="blurred"
                      alt="Difference"
                    />
                  }
                  hoverImage={
                    <StaticImage
                      width={150}
                      loading="lazy"
                      src="../../../images/v5/News/TheHindu.webp"
                      placeholder="blurred"
                      alt="Difference"
                    />
                  }
                  text="“News from the world of Education: August 29, 2024”"
                ></NewsCard>{' '}
              </div>
              <div className="">
                <NewsCard
                  href="https://businessnewsmatters.com/news/crio-do-partners-with-foundation-for-excellence-to-empower-economically-disadvantaged-engineering-students/"
                  image={
                    <StaticImage
                      width={150}
                      loading="lazy"
                      src="../../../images/v5/News/BNM.webp"
                      placeholder="blurred"
                      alt="Difference"
                    />
                  }
                  hoverImage={
                    <StaticImage
                      width={150}
                      loading="lazy"
                      src="../../../images/v5/News/BNM.webp"
                      placeholder="blurred"
                      alt="Difference"
                    />
                  }
                  text="“Crio.Do partners with Foundation For Excellence to empower economically disadvantaged engineering.."
                ></NewsCard>{' '}
              </div>
              <div className="">
                <NewsCard
                  href="https://edu-news.net/news/crio-do-partners-with-foundation-for-excellence-to-empower-economically-disadvantaged-engineering-students/"
                  image={
                    <StaticImage
                      width={150}
                      loading="lazy"
                      src="../../../images/v5/News/EduNews.webp"
                      placeholder="blurred"
                      alt="Difference"
                    />
                  }
                  hoverImage={
                    <StaticImage
                      width={150}
                      loading="lazy"
                      src="../../../images/v5/News/EduNews.webp"
                      placeholder="blurred"
                      alt="Difference"
                    />
                  }
                  text="“Crio.Do partners with Foundation For Excellence to empower economically disadvantaged....“"
                ></NewsCard>
              </div>
            </div>
          </div>
        </div>
      </SectionLayout>
    </RoundedLayout>
  );
});

const NewsCard = ({ href, image, hoverImage, text }) => {
  const [enabled, setEnabled] = useState(false);
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onMouseOver={() => {
        setEnabled(true);
      }}
      onMouseOut={() => {
        setEnabled(false);
      }}
    >
      <div
        className={`flex flex-col items-center gap-y-2 text-center sm:items-start sm:text-left ${
          enabled ? 'bg-v5-green-100' : 'bg-v5-neutral-200'
        } rounded-[20px] p-5 transition-all`}
      >
        <div className="">
          <ImageWithHover
            image={image}
            hoverImage={hoverImage}
            enabled={enabled}
            setEnabled={setEnabled}
          ></ImageWithHover>
        </div>
        <p
          className={`font-bold  leading-relaxed ${
            enabled ? 'text-black' : 'text-v5-neutral-400'
          }`}
        >
          {text}
        </p>
      </div>
    </a>
  );
};

export default InTheNewsSection;
